import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, StyledContent, CloseButton } from './Modal.styles';
import CloseIcon from '@mui/icons-material/Close';
import ModalContent from './ModalContent/ModalContent';

const Modal = ({ children, isActive, setActive, setLastOpenItemId, setTabValue, version }) => {
  const reload = () => {
    setActive?.(false);
    setLastOpenItemId?.(null);
    setTabValue?.(0);
  };

  return (
    <Wrapper isActive={isActive} onClick={reload}>
      <StyledContent isActive={isActive} onClick={(e) => e.stopPropagation()} version={version}>
        {children}
        <CloseButton onClick={reload}>
          <CloseIcon />
        </CloseButton>
      </StyledContent>
    </Wrapper>
  );
};

Modal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default Modal;
